import "../css/custom.css";
import "../css/bootstrap.min.css";
import { Link } from "react-router-dom";

const Footer=()=>{

    // Scroll to top handler
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "instant",
        });
    };

    return(
        <>
        <footer>
            <div className="container">
            <div className="row">
                <div className="col-sm-6" data-aos="fade-up" data-aos-duration="500">

                    <div className="flogo">
                        <img src="/images/logo.svg" alt="EZ Scan go" />
                    </div>
                    <h4>Ez Scan Go</h4>
                    <p>Streamline your retail experience with mobile<br /> Checkout solutions.</p>

                </div>
                <div className="col-sm-3" data-aos="fade-up" data-aos-duration="800">
                    <h4>
                        Quick Links
                    </h4>
                    <ul className="ftrlink">
                        <li><Link to="/aboutUs" onClick={scrollToTop}>About</Link></li>
                        <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li>
                    </ul>
                </div>
                <div className="col-sm-3" data-aos="fade-up" data-aos-duration="800">
                   
                    <ul className="ftrlink">
                        <li><Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link></li>
                        <li><Link to="/terms-and-conditions-merchants" onClick={scrollToTop}>T&C Merchants</Link></li>
                        <li><Link to="/terms-and-conditions-users" onClick={scrollToTop}>T&C Users</Link></li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="container">
            <hr />
            <div className="row pt-2">
                <div className="col-sm-6 text-center text-sm-start">
                    <p className="">&copy; {new Date().getFullYear()} EZ Scan Go | All rights reserved</p>
                </div>
                <div className="col-sm-6 text-center text-sm-end">
                    <p className="">Developed by: <a href="https://heuristticminds.com/" target="_blank">Heuristtic Minds</a></p>
                </div>
            </div>
        </div>
        </footer>
        </>
    )
};
export default Footer;